import '../../../styles/generated-styles/styles-tha-prod.scss';

const StylesLoader = () => <></>;
export default StylesLoader;
